import template from './performance_ratings_report.html';
import tr from '../../../lib/default-translator.js';
import * as Utils from '../../../lib/savanna_utils.js';
import * as PerfManage from '../../../lib/performance_management_functions.js';

class ReportPerfmRatingsViewModel
{
	constructor (page)
	{
		this.page = page;
		this.include_resigned = ko.observable(false);
		this.results = ko.observable([]);

		this.current_department_id = ko.observable(null);
		this.current_company_id = ko.observable(null);

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.selected_employee = ko.observable();
		this.selected_cycle = ko.observable();
		this.selected_filter_by = ko.observable('employee');
		this.steps = ko.observable();

		this.include_resigned.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_company.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_department.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_cycle.subscribe((value) => {
			this.page.updateData();
		});

		this.selected_employee.subscribe((value) => {
			this.page.updateData();
		})
	}

	async download_clicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('perfomance_rating_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;
		
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'perfomance_rating_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	show_report_help()
	{
		Grape.dialog.open('LeaveAvailableHelp', { employee_id: this.page.bindings.id }, {});
	}
}

class ReportPerfmRatingsPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportPerfmRatingsViewModel(this);
	}

	async init()
	{
		// check access to page -- ADD FEATURE ROLE
		/*if (await Utils.redirectOnAccessDenied('PerformanceReport'))
			return;*/

		document.title = tr('Performance Report');
		window.current_page_title(tr('Performance Report'));
	}

	async updateData()
	{
		let data;
		if (this.viewModel.selected_filter_by() == 'employee')
		{
			if (this.viewModel.selected_employee())
				data = { employee_id: this.viewModel.selected_employee().employee_id, include_resigned: this.viewModel.include_resigned() };
			else
				data = { include_resigned: this.viewModel.include_resigned() };

			this.viewModel.selected_department(null);
			this.viewModel.selected_company(null);
		}
		else if (this.viewModel.selected_filter_by() == 'company')
		{
			if (this.viewModel.selected_company())
				data = { company_id: this.viewModel.selected_company().company_id, include_resigned: this.viewModel.include_resigned() };
			else
				data = { include_resigned: this.viewModel.include_resigned() };

			this.viewModel.selected_department(null);
			this.viewModel.selected_employee(null);
		}
		else if (this.viewModel.selected_filter_by() == 'department')
		{
			if (this.viewModel.selected_department())
				data = { department_id: this.viewModel.selected_department().department_id, include_resigned: this.viewModel.include_resigned() };
			else
				data = { include_resigned: this.viewModel.include_resigned() };

			this.viewModel.selected_employee(null);
			this.viewModel.selected_company(null);
		}
		else
			data = { include_resigned: this.viewModel.include_resigned() };

		if (this.viewModel.selected_cycle())
		{
			data.cycle_id = this.viewModel.selected_cycle().performance_cycle_id;
			let steps = await PerfManage.get_steps_progress(this.viewModel.selected_cycle().performance_cycle_id, 1, 'Not Started');
			this.viewModel.steps(steps);
		}

		let res = await Grape.fetches.postJSON('/reports/performance_management/get_performance_report', data);

		if (res)
		{
			if (res.report != null)
			{
				let records = [];
				for (let i = 0; i < res.report.report_data.length; i++)
				{
					let record = res.report.report_data[i];
					record['fullnames'] = record.first_name + ' ' + record.last_name;
					record['department_company'] = record.department + ' (' + record.company + ')';
					records.push(record);
				}

				res.records = records;
				res.total = res.report.result_count;
				res.offset = res.report.report_data.length;
				res.limit = res.report.report_data.length + 2;
				this.viewModel.results(res.records);
			}
		}
	}
}

export default {
	route: '[/]report/performance_management/performance_ratings_report',
	page_class: ReportPerfmRatingsPage,
	template: template,
	template_filename: 'translation/performance_ratings_report'
};